import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JurorComponent } from './juror.component';
import { AcceptedComponent } from '../accepted/accepted.component';
import { RejectedComponent } from '../rejected/rejected.component';
import { UnratedComponent } from '../unrated/unrated.component';
import { RouterModule } from '@angular/router';
import { ShowimgComponent } from '../showimg/showimg.component';
import { JudgeEntryComponent } from '../judge-entry/judge-entry.component';
import { NavEntriesComponent } from '../nav-entries/nav-entries.component';
import { SelectEntryComponent } from '../select-entry/select-entry.component';
import { JurorMenuComponent } from '../jurormenu/jurormenu.component';
import { ReportComponent } from '../report/report.component';

@NgModule({
  declarations: [
    ShowimgComponent,
    NavEntriesComponent,
    SelectEntryComponent,
    JudgeEntryComponent,
    JurorComponent,
    JurorMenuComponent,
    AcceptedComponent,
    RejectedComponent,
    UnratedComponent,
    ReportComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      { path: 'peak', component: JurorComponent},
      { path: 'juror', component: JurorComponent},
      { path: 'juror/accepted', component: AcceptedComponent},
      { path: 'juror/rejected', component: RejectedComponent},
      { path: 'juror/unrated', component: UnratedComponent},
      { path: 'juror/report', component: ReportComponent}
    ])
  ],
  exports: [ NavEntriesComponent ]
})
export class JurorModule { }
